import { all } from 'redux-saga/effects';
import carriersWatcher from './CarriersSaga';

function* carriersSaga() {
  yield all([
    carriersWatcher(),
  ]);
}

export default carriersSaga;
